var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2531 0.725098H1.98017C1.67699 0.725098 1.43121 0.970875 1.43121 1.27406V8.95947C1.43121 9.26265 1.67699 9.50843 1.98017 9.50843H16.2531C16.5563 9.50843 16.802 9.26265 16.802 8.95947V1.27406C16.802 0.970875 16.5563 0.725098 16.2531 0.725098Z",
    stroke: "#132A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11667 7.31257C10.3294 7.31257 11.3125 6.32946 11.3125 5.11673C11.3125 3.90401 10.3294 2.9209 9.11667 2.9209C7.90395 2.9209 6.92084 3.90401 6.92084 5.11673C6.92084 6.32946 7.90395 7.31257 9.11667 7.31257Z",
    stroke: "#276E91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4104 0.725098L16.8021 4.56781",
    stroke: "#132A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4104 9.50824L16.8021 5.66553",
    stroke: "#132A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82288 0.725098L1.43121 4.56781",
    stroke: "#132A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82288 9.50824L1.43121 5.66553",
    stroke: "#132A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.db3f4baaa4cb8940c2c99d344be00787.svg";
export { ForwardRef as ReactComponent };